import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'utils/axiosBaseQuery';

// Define a service using a base URL and expected endpoints
export const pricesApi = createApi({
  reducerPath: 'pricesApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['prices'],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getPricesList: builder.query({
      query: () => ({
        method: 'GET',
        path: `Prices/GetFedexTierList`,
      }),
      providesTags: ['prices'],
    }),
    getFedexPrice: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'POST',
        path: 'Prices/GetFedexPrice',
      }),
    }),
    getFedexTier: builder.query({
      query: ({ id }) => ({
        method: 'GET',
        path: `Prices/GetFedexTier/${id}`,
      }),
      providesTags: ['prices'],
    }),
    createNewPrices: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'POST',
        path: 'Prices/AddFedexTier',
      }),
      invalidatesTags: ['prices'],
    }),
    updatePrices: builder.mutation({
      query: ({ id, data }) => ({
        data,
        method: 'PUT',
        path: `Prices/ChangeFedexTier/${id}`,
      }),
      invalidatesTags: ['prices'],
    }),
    deletePrices: builder.mutation({
      query: ({ id }) => ({
        method: 'DELETE',
        path: `Prices/DeleteFedexTier/${id}`,
      }),
      invalidatesTags: ['prices'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const pricesApiReducerName = pricesApi.reducerPath;
export const pricesApiReducer = pricesApi.reducer;
export const pricesApiMiddleware = pricesApi.middleware;

export const {
  useGetPricesListQuery,
  useGetFedexPriceMutation,
  useGetFedexTierQuery,
  useCreateNewPricesMutation,
  useUpdatePricesMutation,
  useDeletePricesMutation,
} = pricesApi;
